module.exports = __webpack_public_path__ + "static/media/NuevoPack1.aacc7803.JPG";